<div
  type="card"
  class="--flex-column card"
  [ngClass]="{ unactive: data.status !== 1 }"
>
  <div class="top --flex-column" [ngClass]="{ unactive: data.status !== 1 }">
    {{ data.status === 1 ? "Plus" : "Team" }}
  </div>
  <div class="content">
    <div class="left" [ngClass]="{ unactive: data.status !== 1 }">
      {{ data.car }}
    </div>
    <div
      class="right"
      (click)="goToGpt()"
      [ngClass]="{ unactive: data.status !== 1 }"
      [ngStyle]="{ cursor: data.status !== 1 ? 'default' : 'pointer' }"
    >
      发起会话
      <img
        src="../../../../assets/images/Icon-fly.svg"
        [width]="14"
        [height]="14"
        alt=""
      />
    </div>
  </div>
  <div class="border"></div>
  <div class="bottom --flex-row-j!sb">
    <ng-container
      *ngIf="data.status === 0 && data.message !== ''; else elseTemplate"
    >
      <div class="message">
        暂时没有
        <!-- <div class="detail">
          此次停运为<span class="text1">部分停运</span>，将于
          <span class="text2">2024-10-17 11:11:01</span>恢复
        </div> -->
      </div>
    </ng-container>
    <ng-template #elseTemplate>
      <div class="progress">
        <span>{{ data.idle_busy }}</span>
        <mat-progress-bar
          [ngClass]="{ unactive: data.status !== 1 }"
          mode="determinate"
          [value]="data.usage"
        ></mat-progress-bar>
        <span>{{ data.usage }}%</span>
      </div>
    </ng-template>
  </div>
</div>
